import { render, staticRenderFns } from "./hero.vue?vue&type=template&id=4159cc33&scoped=true&"
var script = {}
import style0 from "./hero.vue?vue&type=style&index=0&id=4159cc33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4159cc33",
  null
  
)

export default component.exports